import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/meeting-kiosk.css";
import type { MeetingKioskBootstrap } from "./types";

declare global {
  interface Window {
    renderMeetingKiosk: (bootstrap: MeetingKioskBootstrap) => void;
  }
}

window.renderMeetingKiosk = function renderMeetingKiosk(
  bootstrap: MeetingKioskBootstrap
): void {
  const container = document.getElementById("meeting-kiosk-root");
  if (!container) {
    // eslint-disable-next-line no-console
    console.error("MeetingKiosk: #meeting-kiosk-root not found.");
    return;
  }
  const root = createRoot(container);
  root.render(<App bootstrap={bootstrap} />);
};
